import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-navbar" }
const _hoisted_2 = { class: "c-navbar__logo__svg" }
const _hoisted_3 = {
  key: 0,
  class: "c-navbar__logo__text-baseline"
}
const _hoisted_4 = { class: "c-navbar__right-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "c-navbar__logo"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Logo)
        ]),
        (_ctx.$slots['text-baseline'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "text-baseline")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode(_component_Nav, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "nav")
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right-section")
    ]),
    (_ctx.hasAsideMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "c-navbar__aside-menu-button",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('toggleOpenAsideMenu'))
        }, [
          _createVNode(_component_Icon, {
            name: _ctx.isOpenAsideMenu ? 'close' : 'menu'
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ]))
}